export default __webpack_public_path__ + "static/media/Sitewide cta components.f51c6aa8.jpg";